import { FlagsContextModel } from 'config/useFlagsContext'
import qs from 'qs'

import {
  BACK_TO_ORIGIN_DEFAULT_LABEL,
  BACK_TO_ORIGIN_FLAGGED_BY,
  BACK_TO_ORIGIN_LABELS,
  BackToOriginKey,
  BackToOriginUrlParams,
} from './backToOriginButton-model'

export const isBackToOriginKey = (value?: string): value is BackToOriginKey =>
  !!value && Object.hasOwn(BACK_TO_ORIGIN_LABELS, value)

export const getBackToOriginLabel = (origin?: string): string =>
  isBackToOriginKey(origin) ? BACK_TO_ORIGIN_LABELS[origin] : BACK_TO_ORIGIN_DEFAULT_LABEL

export const buildBackToOriginParams = (backToOriginUrl: string, origin?: BackToOriginKey): string => {
  const params: BackToOriginUrlParams = { backToOriginUrl, backToOriginKey: origin }
  return qs.stringify(params)
}

export const isBackToOriginKeyEnabled = (flags: Partial<FlagsContextModel>, key?: string): boolean => {
  if (!isBackToOriginKey(key)) return true
  return (BACK_TO_ORIGIN_FLAGGED_BY[key] ?? []).every((flag) => !!flags[flag])
}
